import React from 'react';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import ServicesDetailSection from '../components/ServicesDetailSection';
import QuoteFormSection from '../components/QuoteFormSection';
import FeaturedProjectsSection from '../components/FeaturedProjectsSection';
import ProjectGallerySection from '../components/ProjectGallerySection';
import TestimonialsSection from '../components/TestimonialsSection';
import WhyChooseUsSection from '../components/WhyChooseUsSection';
import CallToActionSection from '../components/CallToActionSection';
import Footer from '../components/Footer';
export function HomePage() {
  return <>
      <div id="hero" data-id="element-666">
        <HeroSection data-id="element-667" />
      </div>
      <div id="about" data-id="element-668">
        <AboutSection data-id="element-669" />
      </div>
      <div id="services" data-id="element-670">
        <ServicesDetailSection data-id="element-671" />
      </div>
      <div id="work" data-id="element-672">
        <ProjectGallerySection data-id="element-673" />
      </div>
      <div id="contact" data-id="element-674">
        <QuoteFormSection data-id="element-675" />
      </div>
      <FeaturedProjectsSection data-id="element-676" />
      <div id="testimonials" data-id="element-677">
        <TestimonialsSection data-id="element-678" />
      </div>
      <WhyChooseUsSection data-id="element-679" />
      <CallToActionSection data-id="element-680" />
      <Footer data-id="element-681" />
    </>;
}